function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { useState } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { ArrowCounterclockwise, CheckCircle, CheckSquare, Circle, GearFill, Square } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { resetSettings, setColumnActCode, setColumnEventType, setMatchesHighlighting, setTheme, setWikipediaLinks, THEME_DARK, THEME_LIGHT, useSettingsContext } from '../state/settings';
import { defaultState } from '../state/settings/reducer';
import { deepEqual } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SettingsButton(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShown = _useState2[0],
      setIsShown = _useState2[1];

  var _useSettingsContext = useSettingsContext(),
      state = _useSettingsContext.state,
      dispatch = _useSettingsContext.dispatch;

  var _state$data = state.data,
      theme = _state$data.theme,
      matchesHighlighting = _state$data.matchesHighlighting,
      wikipediaLinks = _state$data.wikipediaLinks,
      columnEventType = _state$data.columnEventType,
      columnActCode = _state$data.columnActCode;

  var setThemeDispatch = function setThemeDispatch(theme) {
    return dispatch(setTheme(theme));
  };

  var createThemeChangeHandler = function createThemeChangeHandler(theme) {
    return function () {
      return setThemeDispatch(theme);
    };
  };

  var setMatchesHighlightingDispatch = function setMatchesHighlightingDispatch(isEnabled) {
    return dispatch(setMatchesHighlighting(isEnabled));
  };

  var setWikipediaLinksDispatch = function setWikipediaLinksDispatch(isEnabled) {
    return dispatch(setWikipediaLinks(isEnabled));
  };

  var setColumnEventTypeDispatch = function setColumnEventTypeDispatch(isEnabled) {
    return dispatch(setColumnEventType(isEnabled));
  };

  var setColumnActCodeDispatch = function setColumnActCodeDispatch(isEnabled) {
    return dispatch(setColumnActCode(isEnabled));
  };

  var resetSettingsDispatch = function resetSettingsDispatch() {
    return dispatch(resetSettings());
  };

  var CheckboxIcon = function CheckboxIcon(_ref2) {
    var _ref2$isEnabled = _ref2.isEnabled,
        isEnabled = _ref2$isEnabled === void 0 ? false : _ref2$isEnabled;
    var Icon = isEnabled ? CheckSquare : Square;
    return /*#__PURE__*/_jsx(Icon, {
      className: "icon mr-2"
    });
  };

  var RadioIcon = function RadioIcon(_ref3) {
    var _ref3$isEnabled = _ref3.isEnabled,
        isEnabled = _ref3$isEnabled === void 0 ? false : _ref3$isEnabled;
    var Icon = isEnabled ? CheckCircle : Circle;
    return /*#__PURE__*/_jsx(Icon, {
      className: "icon mr-2"
    });
  };

  var isSettingsUntouched = deepEqual(state, defaultState);
  return /*#__PURE__*/_jsxs(DropdownButton, _objectSpread(_objectSpread({
    variant: "secondary",
    id: "dropdown-advanced-configuration",
    title: /*#__PURE__*/_jsx(GearFill, {
      className: "icon"
    }),
    as: "span",
    show: isShown,
    onToggle: function onToggle(isOpen, event, metadata) {
      return setIsShown(isOpen ? true : metadata.source === 'select');
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Dropdown.Header, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.search"
      })
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: function onClick() {
        return setMatchesHighlightingDispatch(!matchesHighlighting);
      },
      children: [/*#__PURE__*/_jsx(CheckboxIcon, {
        isEnabled: matchesHighlighting
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.highlight"
      })]
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: function onClick() {
        return setWikipediaLinksDispatch(!wikipediaLinks);
      },
      children: [/*#__PURE__*/_jsx(CheckboxIcon, {
        isEnabled: wikipediaLinks
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.wikipedia_links"
      })]
    }), /*#__PURE__*/_jsx(Dropdown.Header, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.columns"
      })
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: function onClick() {
        return setColumnEventTypeDispatch(!columnEventType);
      },
      children: [/*#__PURE__*/_jsx(CheckboxIcon, {
        isEnabled: columnEventType
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.column_event_type"
      })]
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: function onClick() {
        return setColumnActCodeDispatch(!columnActCode);
      },
      children: [/*#__PURE__*/_jsx(CheckboxIcon, {
        isEnabled: columnActCode
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.column_act_code"
      })]
    }), /*#__PURE__*/_jsx(Dropdown.Header, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.theme"
      })
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: createThemeChangeHandler(THEME_LIGHT),
      children: [/*#__PURE__*/_jsx(RadioIcon, {
        isEnabled: theme === THEME_LIGHT
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.theme_light"
      })]
    }), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: createThemeChangeHandler(THEME_DARK),
      children: [/*#__PURE__*/_jsx(RadioIcon, {
        isEnabled: theme === THEME_DARK
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.theme_dark"
      })]
    }), /*#__PURE__*/_jsx(Dropdown.Divider, {}), /*#__PURE__*/_jsxs(Dropdown.Item, {
      onClick: function onClick() {
        return resetSettingsDispatch();
      },
      disabled: isSettingsUntouched,
      children: [/*#__PURE__*/_jsx(ArrowCounterclockwise, {
        className: "icon mr-2"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "settings.restore"
      })]
    })]
  }));
}